import { Spacing, Text } from '@doordash/design-language'
import * as React from 'react'
import { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

const PageTitle: React.FC<ComponentPropsWithoutRef<'div'>> = ({
  children,
  ...props
}) => (
  <PageTitleContainer {...props}>
    <Text styles={Text.Styles.PageTitle} tag="h1">
      {children}
    </Text>
  </PageTitleContainer>
)

const PageTitleContainer = styled.div`
  margin: ${Spacing.XxLarge}px 0 ${Spacing.XLarge}px;
`

export default PageTitle
